import ApplicationController from './application'

// Gates a form POST with an in-app confirm modal, then requestSubmit so Turbo handles the frame.
export default class extends ApplicationController {
  static values = { message: String }
  static targets = [ 'modal', 'message' ]


  confirm(event) {
    event.preventDefault()
    this.pendingSubmit = event.currentTarget

    const message = this.pendingSubmit.dataset.confirmSubmitMessageValue || this.messageValue
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = message
    }

    this.modalTarget.classList.remove('hidden')
  } // confirm


  cancel(event) {
    event?.preventDefault()
    this.modalTarget.classList.add('hidden')
  } // cancel


  submit(event) {
    event.preventDefault()
    this.modalTarget.classList.add('hidden')

    const submitter = this.pendingSubmit
    this.pendingSubmit = null

    // requestSubmit(submitter) requires type="submit"; gate buttons are type="button".
    if (submitter?.type === 'submit') {
      this.setBusy(submitter)
      this.element.requestSubmit(submitter)
      return
    }

    if (submitter) {
      this.setBusy(submitter)
      const action = submitter.getAttribute('formaction')
      const method = submitter.getAttribute('formmethod')
      if (action) this.element.action = action
      if (method) this.element.method = method
    }

    this.element.requestSubmit()
  } // submit


  setBusy(button) {
    const busyLabel = button.dataset.turboSubmitsWith
    if (busyLabel) {
      button.dataset.confirmSubmitOriginalLabel = button.textContent.trim()
      button.textContent = busyLabel
    }

    button.disabled = true
    button.classList.add('opacity-50', 'cursor-not-allowed', 'pointer-events-none')
  } // setBusy

}
